$(document).ready(function ($pd) {
  const windowLocation = theme.windowLocation;
  const diamond_product_parent = $(".product-single");
  var diamond_closure = theme.diamond_url;
  var server_closure = theme.server_url;
  var diamond_image_url = "";
  const helper = {
    set_local_storage: function (name, value) {
      localStorage.setItem(name, value);
    },
    get_local_storage: function (name) {
      return localStorage.getItem(name);
    },
    remove_local_storage: function (name) {
      localStorage.removeItem(name);
    },
    set_local_diamond_session: function (name, value) {
      localStorage.setItem(name, value);
    },
    get_local_diamond_session: function (name, value) {
      localStorage.setItem(name, value);
    },
    remove_local_diamond_session: function (name, value) {
      localStorage.setItem(name, value);
    },
    scroll_to_diamond_tab: function () {
      $(document).on("click", ".diamond-more-info", function () {
        var target = $(".product_description--accordion");
        if (target.length) {
          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            500
          );
        }
      });
    },
    price: function (diamond) {
      var currency_symbol = theme.country_currency_symbol;
      var currency_conversion_rate = 1;
      switch (theme.country_iso_code) {
        case "GB":
          currency_conversion_rate = 0.81;
          break;
        case "CA":
          currency_conversion_rate = 1.37;
          break;
        case "AU":
          currency_conversion_rate = 1.54;
          break;
        default:
      }
      var price = parseInt(
          diamond.total_discounted_sales_price * currency_conversion_rate
        ),
        compare_price = parseInt(
          diamond.total_sales_price * currency_conversion_rate
        ),
        percentOff = `${currency_symbol}${compare_price - price} OFF`,
        bank_wire_price = parseInt(
          diamond.bank_wire_price_in_currency * currency_conversion_rate
        );
      return [
        price,
        compare_price,
        percentOff,
        bank_wire_price,
        currency_symbol,
      ];
    },
    diamond_price_html: function (diamond) {
      var [price, compare_price, percentOff, bank_wire_price, currency_symbol] =
        helper.price(diamond);
      let priceHtml;
      $("#product-content").text(price);
      if (diamond.discount_perc) {
        priceHtml = `<div class="prodcut__price price--on-sale">
            <div class="price__on-sale">${currency_symbol}${price.toLocaleString(
          "en-US"
        )}</div>
            <div class="price__regular">${currency_symbol}${compare_price.toLocaleString(
          "en-US"
        )}</div>
            <div class="precentage_off">(${percentOff})</div>
            <div class="diamond__only">(Diamond Only)</div>
        </div>
        <div class="bank-wire-price">BANK WIRE PRICE ${currency_symbol}${bank_wire_price.toLocaleString(
          "en-US"
        )}</div>`;
      } else {
        priceHtml = `<div class="prodcut__price">
            <div class="price__on-sale">${currency_symbol}${price.toLocaleString(
          "en-US"
        )}</div>
            <div class="diamond__only">(Diamond Only)</div>
        </div>
        <div class="bank-wire-price">BANK WIRE PRICE $${bank_wire_price.toLocaleString(
          "en-US"
        )}</div>`;
      }
      $(".product-single__price").html(priceHtml);
      $(".affirm-info-wrapper").html(`<p
        class="affirm-as-low-as"
        data-page-type="product"
        data-amount="${price * 100}"></p>`);
    },
    diamond_information: function (diamond) {
      $(".shape-info").text(diamond.shape);
      $(".carat-info").text(diamond.size);
      $(".cut-info").text(diamond.cut);
      $(".color-info").text(diamond.color);
      $(".clarity-info").text(diamond.clarity);
      $(".polish-info").text(diamond.polish);
      $(".symmetry-info").text(diamond.symmetry);
      $(".fluorescence-info").text(diamond.fluor_intensity);
      $(".table-info").text(diamond.table_percent + "%");
      $(".depth-info").text(diamond.depth_percent + "%");
      $(".measurements-info").text(diamond.measurements);
      $(".l-w-ratio-info").text(diamond.ratio);
      $(".certificate-type-info").text(diamond.lab);
      $(".lab-name").html(`${diamond.lab}`);
      $(".diamond-certificate-link").attr("href", diamond.cert_url);
      $(".product-single__title").text(diamond.diamond_name);
      $(".certificate-number,.product-single__sku span").html(
        `${diamond.cert_num}`
      );
      // alert();
      if (diamond?.color_intensity) {
        $(".intensity-info").text(diamond?.color_intensity);
      } else {
        $(".intensity-info").closest(".color-intensity").hide();
      }

      document.title = diamond.diamond_name;
      if (diamond.diamond_name.indexOf("Lab") > -1) {
        $(".price-match-guarantee").show();
        $(".lifetime-diamond-upgrade").hide();
      } else {
        $(".price-match-guarantee").hide();
        $(".lifetime-diamond-upgrade").show();
      }
      // add shape class to hand image
      $(".hand_diamond_img").addClass(diamond.shape.toLowerCase());
    },
    related_diamond_html: function (diamond) {
      var diamond_label = "";
      switch (diamond.type) {
        case "color":
          diamond_label = "Higher color";
          break;
        case "clarity":
          diamond_label = "Better clarity";
          break;
        default:
          diamond_label = "Larger carat size";
          break;
      }
      var [price, , , , currency_symbol] = helper.price(diamond);
      var currency_conversion_rate = 1;
      switch (currency_symbol) {
        case "GB":
          currency_conversion_rate = 0.81;
          break;
        case "CA":
          currency_conversion_rate = 1.37;
          break;
        case "AU":
          currency_conversion_rate = 1.54;
          break;
        default:
      }
      var price_difference =
        diamond.price_difference * currency_conversion_rate;
      return `<a class="related-diamond-detail real-related-block" href="${
        theme.diamond_product_url
      }?sku=${diamond?.diamond_id}">
        <div class="related-diamond-blocks">
                <div class="related-diamond-image-wrapper">
                  <div class="diamond-image-container">
                    <img src="${diamond.diamond_image}" />
                  </div>
                </div>
                <div class="diamond-block-details">
                    <p class="diamond-block-title">${diamond_label}</p>
                    <p class="diamond-block-price diamond-block-info">
                        Price: <span>${currency_symbol}${price.toLocaleString(
        "en-US"
      )}</span><span class="price-differ"> (+${currency_symbol}${price_difference.toLocaleString(
        "en-US"
      )})</span>
                    </p>
                    <p class="diamond-block-carat diamond-block-info">
                        carat: <span>${diamond.carat_weight}</span>
                    </p>
                    <p class="diamond-block-color diamond-block-info">
                        color: <span>${diamond.color}</span>
                    </p>
                    <p class="diamond-block-clarity diamond-block-info">
                        clarity: <span>${diamond.clarity}</span>
                    </p>
                </div>
                </div>
            </a>`;
    },
    insert_related_diamond_html: function (diamond_obj, pdp_diamond) {
      // var [price, compare_price, percentOff, bank_wire_price] =
      var [price, , , , currency_symbol] = helper.price(pdp_diamond);
      console.log(diamond_obj, pdp_diamond);
      if (!diamond_obj) {
        $(".diamond-related-products").remove();
        return false;
      }
      var diamond_html = "",
        new_sorting_obj = {},
        high_carat,
        high_color,
        high_clarity;
      diamond_html += `<a class="pdp-daimond-detail real-related-block" href="${
        theme.diamond_product_url
      }?sku=${pdp_diamond?.cert_num}">
                <div class="related-diamond-blocks">
                  <div class="related-diamond-image-wrapper">
                    <div class="diamond-image-container">
                      <img src="${pdp_diamond.image_url}" />
                    </div>
                  </div>
                  <div class="diamond-block-details">
                      <p class="diamond-block-title">Current diamond</p>
                      <p class="diamond-block-price diamond-block-info">
                          Price: <span>${currency_symbol}${price.toLocaleString(
        "en-US"
      )}</span>
                      </p>
                      <p class="diamond-block-carat diamond-block-info">
                          carat: <span>${pdp_diamond.size}</span>
                      </p>
                      <p class="diamond-block-color diamond-block-info">
                          color: <span>${pdp_diamond.color}</span>
                      </p>
                      <p class="diamond-block-clarity diamond-block-info">
                          clarity: <span>${pdp_diamond.clarity}</span>
                      </p>
                  </div>
                </div>
            </a>`;
      diamond_obj.forEach(function (diamond, index) {
        new_sorting_obj[diamond.type] = diamond;
      });
      console.log(new_sorting_obj.length, new_sorting_obj);
      var count = 0;
      if (!new_sorting_obj["color"].remarks) {
        high_color = helper.related_diamond_html(new_sorting_obj["color"]);
        diamond_html += high_color;
        count += 1;
      }
      if (!new_sorting_obj["clarity"].remarks) {
        high_clarity = helper.related_diamond_html(new_sorting_obj["clarity"]);
        diamond_html += high_clarity;
        count += 1;
      }
      if (!new_sorting_obj["carat"].remarks) {
        high_carat = helper.related_diamond_html(new_sorting_obj["carat"]);
        diamond_html += high_carat;
        count += 1;
      }
      console.log(count);
      if (count == 0) {
        $(".diamond-related-products").remove();
        return false;
      }
      if (diamond_obj) {
        $(".dummy-related-products-rendering").hide();
        $(".real-related-products-rendering")
          .html(diamond_html)
          .css({ display: "flex" });
      }
    },
    load_media: function (diamond) {
      let iframe_cout = 0;
      //   Diamond Image
      let diamond_image = diamond?.image_url;
      diamond_image_url = diamond_image;
      if (diamond_image) {
        const img = document.createElement("img");
        img.src = `${diamond_image}`;
        diamond_product_parent
          .find(".diamond-image .diamond-image-grid")
          .html(
            `<div class="image-wrapper"><img src="${diamond_image}"/></div>`
          );
        $(".diamond-thumbnil.diamond-image").append(img);
      }
      if (diamond?.lab && diamond?.lab == "IGI") {
        $('[data-type="diamond-certificate"] img').attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0757/8851/7659/files/IGI_Logo.jpg?v=1764739660"
        );
      }
      if (diamond?.lab && diamond?.lab == "GIA") {
        $('[data-type="diamond-certificate"] img').attr(
          "src",
          "https://cdn.shopify.com/s/files/1/0757/8851/7659/files/gia-certificate-logo.png?v=1757328487"
        );
      }
      if (diamond?.cert_url) {
        $('[data-type="diamond-certificate"] a').attr(
          "href",
          diamond?.cert_url
        );
      }
      if (!diamond?.video_url) {
        $(".diamond-thumbnil.diamond-360").hide();
      }
      // Code to resize 360 video in mobile
      const windowWidth = Math.floor(
        $(".product-single__diamond-group .diamond-image-wrapper").width()
      );
      var video_url_with_size = diamond.video_url;
      try {
        if (
          windowWidth < 550 &&
          video_url_with_size.indexOf("loupe360.com") > -1
        ) {
          const video_url = diamond.video_url.split("/video/");
          video_url_with_size =
            video_url[0] + `/video/${windowWidth}/${windowWidth}/true`;
        } else if (video_url_with_size.indexOf("loupe360.com") > -1) {
          video_url_with_size = video_url_with_size + "/true";
        }
      } catch (e) {
        console.log(e);
      }

      // $(".diamond-iframe iframe").remove();
      // var newDiamondIframe = `<iframe width="600px" height="600px" src="${video_url_with_size}"></iframe>`
      // // .attr("src", video_url_with_size);
      // $(".diamond-iframe .diamond-image-grid").append(newDiamondIframe);
      $(".diamond-thumbnil:not(.diamond-certificate)").on("click", function () {
        $(".diamond-thumbnil").removeClass("active");
        $(".diamond-image-wrapper > [class*=diamond]").hide();
        const data_type = $(this).data("type");
        $(this).addClass("active");
        $("." + data_type).show();

        if (!iframe_cout && data_type == "diamond-iframe") {
          $(".diamond-iframe iframe").attr("src", video_url_with_size);
          $(".diamond-iframe iframe").on("load", function () {
            console.log("load", $(this).contents().height() + "is the height");
          });
          iframe_cout += 1;
        }
      });

      /*
        1. Remove hand_diamond_img div,class and script
        2. Remove custom-handle div,class and script
        3. 
      */

      var softSlider = document.getElementById("slider");
      var diamond_carat_images_obj = JSON.parse(
        $("#diamond-image-json").text()
      );
      var diamond_shape = diamond_carat_images_obj[diamond.shape];
      var valuesForSlider = [0, 1, 2, 3, 4, 5, 6, 7, 8];
      var format = {
        to: function (value) {
          return valuesForSlider[Math.round(value)];
        },
        from: function (value) {
          return valuesForSlider.indexOf(Number(value));
        },
      };
      var formatForSlider = {
        from: function (formattedValue) {
          return Number(formattedValue);
        },
        to: function (numericValue) {
          return numericValue.toFixed(2);
        },
      };
      noUiSlider.create(softSlider, {
        start: 1,
        // A linear range from 0 to 15 (16 values)
        //range: { min: 0, max: valuesForSlider.length - 1 },
        range: {
          min: [0, 0.25],
          "12.5%": [1, 0.25],
          "25%": [2, 0.25],
          "37.5%": [3, 0.25],
          "50%": [4, 0.5],
          "62.5%": [5, 0.5],
          "75%": [6, 0.5],
          "87.5%": [7, 1],
          max: [8],
        },
        // steps of 1
        step: 1,
        tooltips: true,
        format: formatForSlider,
        pips: { mode: "steps", format: formatForSlider },
      });
      softSlider.noUiSlider.on("update", function (values, handle) {
        $(".diamond-on-hand img").attr("src", diamond_shape[values[0]]);
      });
      var imageContainer = document.querySelector(".load-diamond-images");
      for (let key in diamond_shape) {
        // Create a new image element
        var img = document.createElement("img");
        // Set the source of the image
        img.src = diamond_shape[key]; // Replace with your image path
        imageContainer.appendChild(img);
      }
    },
    section_tab_slider: function () {
      const diamond_section_slider = $(".diamond-education__content-wrapper");
      if (diamond_section_slider.length) {
        diamond_section_slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
        });
      }
      $(".diamond-education__tab").on("click", function () {
        const data_tab = $(this).data("tab");
        $(this)
          .closest(".shopify-section")
          .find(".diamond-education__tab")
          .removeClass("active");
        $(this).addClass("active");
        console.log(data_tab);
        const slide_index = $(
          '.diamond-education__content[data-type="' + data_tab + '"]'
        ).data("slick-index");
        $(this)
          .closest(".shopify-section")
          .find(".diamond-education__content-wrapper")
          .slick("slickGoTo", slide_index);
      });
    },
    mobileImageSlide: function () {
      // PDP - Diamond group slider
      if ($(window).width() < 750) {
        $(".diamond-education__tabs").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
        });
      }
    },
  };

  helper.mobileImageSlide();
  helper.section_tab_slider();
  helper.scroll_to_diamond_tab();

  var calculator = {
    workDaysAdded: 0,
    month: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ],
    monthFull: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    weekday: ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"],
    weekdayFull: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    ukHolidays: ["2025-11-27",   "2025-12-25","2026-01-01"],  //"2023-05-23", "2023-05-24" "2025-12-25","2026-01-01"
    startDate: null,
    curDate: null,

    addWorkDay: function () {
      this.curDate.setDate(this.curDate.getDate() + 1);
      if (
        this.ukHolidays.indexOf(this.formatDate(this.curDate)) === -1 &&
        this.curDate.getDay() !== 0 &&
        this.curDate.getDay() !== 6
      ) {
        this.workDaysAdded++;
      }
    },

    formatDate: function (date) {
      var day = date.getDate(),
        month = date.getMonth() + 1;

      month = month > 9 ? month : "0" + month;
      day = day > 9 ? day : "0" + day;
      return date.getFullYear() + "-" + month + "-" + day;
    },

    getNewWorkDay: function (daysToAdd) {
      this.startDate = new Date();
      this.curDate = new Date();
      this.workDaysAdded = 0;

      while (this.workDaysAdded < daysToAdd) {
        this.addWorkDay();
      }
      return [
        this.weekday[this.curDate.getDay()],
        this.month[this.curDate.getMonth()],
        this.curDate.getDate(),
        this.weekdayFull[this.curDate.getDay()],
        this.monthFull[this.curDate.getMonth()],
      ];
    },
  };
  function shipping_work_day(day) {
    var newWorkDay7 = calculator.getNewWorkDay(day);
    var newWorkDay8 = calculator.getNewWorkDay(day);
    $(".product-form_ship-loose-timeline b").text(`${newWorkDay7[0]}, ${newWorkDay7[1]} ${newWorkDay7[2]}`);
    $(".product-form_ship-in-ring-timeline b").text(`${newWorkDay8[0]}, ${newWorkDay8[1]} ${newWorkDay8[2]}`);
    $("#properties-ship-by").val(`${newWorkDay7[3]}, ${newWorkDay7[4]} ${newWorkDay7[2]}`);
  }
  shipping_work_day(9);

  function update_related_diamonds_obj(diamond_id, related_diamond_obj) {
    let related_diamonds_obj = theme.get_local_storage("related-diamonds-obj");
    if (related_diamonds_obj) {
      related_diamonds_obj = JSON.parse(related_diamonds_obj);
    } else {
      related_diamonds_obj = {};
    }
    // push diamond information in session object
    related_diamonds_obj[diamond_id] = related_diamond_obj;
    theme.set_local_storage(
      "related-diamonds-obj",
      JSON.stringify(related_diamonds_obj)
    );
  }

  function fetch_related_diamond_data(diamond_id, pdp_diamond) {
    console.log("Fetching + Network call");
    var pull_realated = { diamond_id };
    var jsonData = {
      filter: [],
    };
    jsonData.filter.push(pull_realated);
    console.log(jsonData);
    axios
      .post(`${server_closure}/diamondrecommendation`, jsonData)
      .then((res) => {
        console.log(res.data);
        var [a, b, c] = res.data;

        helper.insert_related_diamond_html([a, b, c], pdp_diamond);
        update_related_diamonds_obj(diamond_id, [a, b, c]);
      })
      .catch((err) => {
        $(".diamond-related-products").remove();
        console.log(err);
      });
  }
  function load_related_diamonds(diamond_id, pdp_diamond) {
    var related_diamonds_list =
        JSON.parse(theme.get_local_storage("related-diamonds-obj")) || null,
      related_diamond_obj;
    if (!related_diamonds_list) {
      fetch_related_diamond_data(diamond_id, pdp_diamond);
    } else {
      if (!related_diamonds_list[diamond_id]) {
        fetch_related_diamond_data(diamond_id, pdp_diamond);
      } else {
        related_diamond_obj = related_diamonds_list[diamond_id];
        helper.insert_related_diamond_html(related_diamond_obj, pdp_diamond);
      }
    }
  }

  function show_diamond_info_on_pdp(selected_diamond) {
    /**************** Show dimonds information in pdp if available *************/
    if (selected_diamond && selected_diamond?.cert_num) {
      $("body").addClass("diamond-available");
    } else {
      $("body").addClass("diamond-not-available");
      return false;
    }
    //   Diamond Iframe
    helper.load_media(selected_diamond);
    //   Diamond Price
    helper.diamond_price_html(selected_diamond);
    //   Diamond information update
    helper.diamond_information(selected_diamond);
  }

  function set_diamond_pdp_information(diamond_info) {
    let diamond_pdp_obj = theme.get_local_storage("diamond-pdp-obj");
    if (diamond_pdp_obj) {
      diamond_pdp_obj = JSON.parse(diamond_pdp_obj);
    } else {
      diamond_pdp_obj = {};
    }

    if (!diamond_info) {
      $("body").addClass("diamond-not-available");
      return false;
    }
    // push diamond information in session object
    diamond_pdp_obj[diamond_info.cert_num] = diamond_info;
    theme.set_local_storage("diamond-pdp-obj", JSON.stringify(diamond_pdp_obj));
  }

  function fetch_diamond_data(diamond_id) {
    const jsonData = {
      filter: [{ diamond_id: diamond_id }],
    };
    axios
      .post(`${server_closure}/fetchparticulardiamonddetail/`, jsonData)
      .then((res) => {
        console.log("loaded data on ajax", res.data.data.liveDiamondData);
        const diamond_info = res.data.data.liveDiamondData.diamond[0];
        if (diamond_info) {
          set_diamond_pdp_information(diamond_info);
        }
        show_diamond_info_on_pdp(diamond_info);
        //load related diamond information
        load_related_diamonds(diamond_id, diamond_info);
      })
      .catch((err) => {
        console.log(err);
      });
    //
  }
  if (windowLocation.indexOf(theme.diamond_product_url) > -1) {
    /**************** Check if diamond is available on page load *************/
    let selected_diamond;
    let diamond_list =
      JSON.parse(theme.get_local_storage("diamond-pdp-obj")) || null;
    const diamond_link = windowLocation.split(theme.diamond_product_url)[1];
    const diamond_id_with_amp = diamond_link.split("?sku=")[1].replace("/", "");
    const diamond_id = diamond_id_with_amp.split("&")[0].replace("/", "");
    const cert_regex = /^[0-9]{6,15}$/;
    console.log(cert_regex.test(diamond_id), diamond_id);
    if (
      diamond_list &&
      cert_regex.test(diamond_id) &&
      diamond_list[diamond_id]
    ) {
      // if regex pattern matches and diamond id key matches to object return diamond and store in local storage
      selected_diamond = diamond_list[diamond_id];
      set_diamond_pdp_information(selected_diamond); // store pdp diamond information in local storage
      show_diamond_info_on_pdp(selected_diamond);
      //load related diamond information
      load_related_diamonds(diamond_id, selected_diamond);
    } else if (cert_regex.test(diamond_id)) {
      // if diamond not available in diamond object then search in database
      fetch_diamond_data(diamond_id);
    } else {
      console.log("a");
      $("body").addClass("diamond-not-available");
      return false;
    }

    // Add loose diamond to ring
    $(".product-form__add-to-setting button").on("click", function () {
      diamond_list =
        JSON.parse(theme.get_local_storage("diamond-pdp-obj")) || null;
      $(this)
        .closest(".product-form__add-to-setting")
        .addClass("button-active");
      const get_pdp_diamond = diamond_list[diamond_id];
      helper.set_local_storage(
        "diamond-information",
        JSON.stringify(get_pdp_diamond)
      );
      const ring_settings = helper.get_local_storage("setting-information");
      // Get selected diamond shape and if ring selected then load ring shape variant similar to diamond shape
      console.log(get_pdp_diamond);
      // const diamond_information_json = JSON.parse(get_pdp_diamond);
      const diamond_shape = get_pdp_diamond.shape;
      // return false;
      if (ring_settings) {
        const ring_settings_json = JSON.parse(ring_settings);
        const variantId = ring_settings_json.variants[diamond_shape];
        window.location.href = `${ring_settings_json.url}?variant=${variantId}&view=final-ring&diamond=${get_pdp_diamond.cert_num}`;
      } else {
        window.location.href = `/collections/${theme.ring_setting_handle}`;
      }
    });

    // function to return diamond information
    function final_diamond_info(selected_diamond) {
      console.log(selected_diamond);
      var price = parseInt(selected_diamond.total_discounted_sales_price);
      // if (selected_diamond?.size > 1.99) {
      //   price = price - 250;
      // }
      const compare_price = parseInt(selected_diamond.total_sales_price);
      let actual_compare_price = "";
      if (compare_price > price) {
        actual_compare_price = selected_diamond.total_sales_price;
      }
      let formattedDiamondName = selected_diamond.diamond_name.toLowerCase().replace(/\./g, "-").replace(/\s+/g, "-");
      let handle = `diamond-${formattedDiamondName}-${selected_diamond.cert_num}`;
      return {
        product: {
          title: selected_diamond.diamond_name,
          handle: `${handle}`,
          body_html: `<h2>
                        Diamond Detail:
                      </h2>
                      <ul>
                        <li>diamond_name ${selected_diamond?.diamond_name}</li>
                        <li>Shape ${selected_diamond?.shape}</li>
                        <li>measurements ${selected_diamond?.measurements}</li>
                        <li>Carat ${selected_diamond?.size}</li>
                        <li>Cut ${selected_diamond?.cut}</li>
                        <li>Color ${selected_diamond?.color}</li>
                        <li>Clarity ${selected_diamond?.clarity}</li>
                        <li>Polish ${selected_diamond?.polish}</li>
                        <li>Symmetry ${selected_diamond?.symmetry}</li>
                        <li>Fluorescence ${selected_diamond?.fluor_intensity}</li>                                                                      
                        <li>Table ${selected_diamond?.table_percent}%</li>                        
                        <li>Depth ${selected_diamond?.depth_percent}%</li>
                        <li>L/W Ratio ${selected_diamond?.ratio}</li>
                        <li>Depth ${selected_diamond?.depth_percent}</li>
                        <li>Certificate type ${selected_diamond?.lab}</li>
                        <li>Certificate Number ${selected_diamond?.cert_num}</li>
                        <li>Price ${selected_diamond?.total_discounted_sales_price}</li>
                        <li>Compare Price ${selected_diamond?.total_sales_price}</li>
                        <li>Cert_url ${selected_diamond?.cert_url}</li>
                        <li>Vault Discount ${selected_diamond?.vaultDiscount}</li>
                      </ul>`,
          vendor: "With Clarity",
          product_type: "Diamond",
          tags: [
            "hidden-on-front-end",
            "ring diamond",
            `${selected_diamond?.lab}`,
          ],
          // weight: selected_diamond.size,
          // weight_unit: "g",
          variants: [
            {
              price: price,
              compare_at_price: actual_compare_price,
              inventory_management: "shopify",
              inventory_policy: "deny",
              inventory_quantity: 1,
              sku: selected_diamond.cert_num,
              weight: selected_diamond.size,
              weight_unit: "g",
              title: "rgl-diamond-110718",
            },
          ],
          images: [{ src: diamond_image_url }],
        },
      };
    }
    function show_error_message(_this) {
      _this
        .closest(".product-form__controls-group")
        .find(".error-message")
        .text(
          "This diamond is already in your shopping cart and can only be added once. Please remove the diamond and try again."
        )
        .show();
      _this.removeClass("disabled").removeAttr("disabled");
    }
    function hide_error_message(_this) {
      _this
        .closest(".product-form__controls-group")
        .find(".error-message")
        .hide();
      _this.addClass("disabled").attr("disabled", "disabled");
    }

    // hide loading icon
    function hide_loading_icon(_this) {
      _this.removeClass("button-active");
      _this.removeClass("disabled").removeAttr("disabled");
    }
    // Add loose diamond to cart
    $(".product-form__buy-loose button").on("click", function () {
      const _this = $(this);
      // Show lazy loading
      _this.addClass("button-active");
      // Hide error message
      hide_error_message(_this);

      // pull diamond object agian from storage to prevent the error of missing diamond information if someone directly visited the diamond product
      diamond_list =
        JSON.parse(theme.get_local_storage("diamond-pdp-obj")) || null;
      // console.log(diamond_list, diamond_id);
      selected_diamond = diamond_list[diamond_id];
      // console.log(selected_diamond);

      var post_data = final_diamond_info(selected_diamond);
      // console.log(post_data);

      // Remove localstorage
      // Clear ring_step data
      function clear_storage() {
        // localStorage.removeItem("diamond-pdp-obj");
        sessionStorage.removeItem("diamond-checklist");
        sessionStorage.removeItem("unavailable_diamond");
      }
      // Function to add product to cart
      function add_loose_product(data) {
        const shipping_date = $("#properties-ship-by").val();
        var shipping_day = "7";
        var looseDiamond = { id: "", quantity: "", properties: {} };
        looseDiamond.id = data.variant_id;
        looseDiamond.quantity = 1;
        looseDiamond.properties["Color"] = selected_diamond?.color;
        looseDiamond.properties["Clarity"] = selected_diamond?.clarity;
        looseDiamond.properties["Lab"] = selected_diamond?.lab;
        looseDiamond.properties["_Measurement"] =
          selected_diamond?.measurements;
        looseDiamond.properties["_Shape"] = selected_diamond?.shape;
        looseDiamond.properties["_Ship By"] = shipping_date;
        looseDiamond.properties["_Ship In"] = shipping_day;
        looseDiamond.properties["_Product Type"] = "Diamond";
        console.log(looseDiamond);
        axios
          .post(`/cart/add.js`, looseDiamond)
          .then(({ data }) => {
            console.log(data);
            clear_storage();
            window.location.href = "/cart";
          })
          .catch((err) => {
            console.log(err);
            hide_loading_icon(_this);
          });
      }
      var currency_conversion_rate = 1;
      switch (theme.country_iso_code) {
        case "GB":
          currency_conversion_rate = 0.81;
          break;
        case "CA":
          currency_conversion_rate = 1.37;
          break;
        case "AU":
          currency_conversion_rate = 1.54;
          break;
        default:
      }
      // Feed price is stored in shop dollars. Storefront product.js prices are presentment cents.
      function to_feed_dollars(cents) {
        if (cents === null || cents === undefined || cents === "") return null;
        const amount = Number(cents) / 100 / currency_conversion_rate;
        if (!Number.isFinite(amount)) return null;
        return Math.round(amount);
      }
      function feed_amount(value) {
        if (value === null || value === undefined || value === "") return null;
        const amount = Number(value);
        if (!Number.isFinite(amount)) return null;
        return Math.round(amount);
      }
      function diamond_prices_match(product, diamond_post_data) {
        const variant = product && product.variants && product.variants[0];
        const feedVariant =
          diamond_post_data &&
          diamond_post_data.product &&
          diamond_post_data.product.variants &&
          diamond_post_data.product.variants[0];
        if (!variant || !feedVariant) return false;
        if (to_feed_dollars(variant.price) !== feed_amount(feedVariant.price)) {
          return false;
        }
        return (
          to_feed_dollars(variant.compare_at_price) ===
          feed_amount(feedVariant.compare_at_price)
        );
      }
      // Function to create product on fly
      function create_loose_product() {
        axios
          .post(`${diamond_closure}/create-product`, post_data)
          .then(({ data }) => {
            add_loose_product(data);
          })
          .catch((err) => {
            console.log(err);
            hide_loading_icon(_this);
          });
      }
      function update_diamond_price(product) {
        const feedVariant = post_data.product.variants[0];
        axios
          .post(`${diamond_closure}/update-diamond-price`, {
            product_id: product.id,
            handle: post_data.product.handle,
            price: feedVariant.price,
            compare_at_price: feedVariant.compare_at_price,
          })
          .then(({ data }) => {
            add_loose_product(data);
          })
          .catch((err) => {
            console.log(err);
            hide_loading_icon(_this);
          });
      }
      // Look up the diamond by handle before creating it.
      function add_or_create_diamond() {
        const handle = post_data && post_data.product && post_data.product.handle;
        if (!handle) {
          create_loose_product();
          return;
        }
        axios
          .get(`/products/${encodeURIComponent(handle)}.js`)
          .then(({ data }) => {
            if (diamond_prices_match(data, post_data)) {
              add_loose_product({ variant_id: data.variants[0].id });
              return;
            }
            update_diamond_price(data);
          })
          .catch((err) => {
            if (err && err.response && err.response.status === 404) {
              create_loose_product();
              return;
            }
            console.log(err);
            hide_loading_icon(_this);
          });
      }
      // Function to check if same product is already in cart
      function is_product_already_in_cart() {
        // let item_has_same_sku = false;
        // const select_diamond = selected_diamond.cert_num;
        // theme.cart_items.filter(function (item) {
        //   var diamondSKU = item?.properties['_Diamond sku'] || "not available";
        //   if (select_diamond.indexOf(item.sku) > -1 || select_diamond.indexOf(diamondSKU) > -1) {
        //     item_has_same_sku = true;
        //   }
        // });
        // if (!item_has_same_sku) {
        //   create_loose_product();
        // } else {
        //   show_error_message(_this);
        //   hide_loading_icon(_this);
        // }
        // console.log(item_has_same_sku);
        // return false;
        axios
          .get(`/cart.js`)
          .then(({ data }) => {
            console.log(data);
            const cart_item_length = theme.cart_items.length;
            if (cart_item_length) {
              var item_has_same_sku = false;
              const select_diamond = selected_diamond.cert_num;
              data.items.filter(function (item) {
                var diamondSKU = item?.properties['_Diamond sku'] || "not available";
                if (select_diamond.indexOf(item.sku) > -1 || select_diamond.indexOf(diamondSKU) > -1) {
                  item_has_same_sku = true;
                }
              });
              if (!item_has_same_sku) {
                add_or_create_diamond();
              } else {
                show_error_message(_this);
                hide_loading_icon(_this);
              }
            } else {
              add_or_create_diamond();
            }
          })
          .catch((err) => {
            hide_loading_icon(_this);
          });
      }
      is_product_already_in_cart();
    });
  }
});
